

























































import { Vue, Component, Prop } from "vue-property-decorator";
import Modal from "@/components/form/Modal.vue";
import FileManager from "@/components/files/FileManager.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { uniq } from "lodash";

@Component({ components: { CustomButton, FileManager, Modal } })
export default class EntityFiles extends Vue {
  @Prop({ default: () => [] }) entityFiles!: any;
  @Prop({ default: false }) isLoading!: any;
  @Prop({ default: true }) isShowFileManagerButton!: any;
  @Prop({ default: false }) generatePdfIcon?: boolean;
  @Prop({ default: false }) showQr?: boolean;
  @Prop({ default: true }) showRemove?: boolean;
  isShowFileManager: boolean = false;

  files: Array<any> = [];

  filePdf = (file: any) => {
    return file?.mimeType === "application/pdf";
  };

  get selectedCompanyId() {
    return this.$store.getters.selectedCompany.id
      ? this.$store.getters.selectedCompany
      : false;
  }

  fileIsDocx = (file: any) => {
    return (
      file?.mimeType ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    );
  };

  generatePdf(file: any) {
    this.$emit("generatePdf", file);
  }

  addFiles(files: Array<any>) {
    let filesArray = files.filter((el: any) => el.type === "File");
    this.$emit(
      "getFilesIds",
      uniq([
        ...this.entityFiles.map((el: any) => el.id),
        ...filesArray.map((el: any) => el.id)
      ])
    );
    this.isShowFileManager = false;
  }

  removeFile(id: string) {
    this.$emit(
      "remFilesIds",
      uniq([
        ...this.entityFiles
          .filter((el: any) => el.id !== id)
          .map((el: any) => el.id)
      ])
    );
  }
}
